//
//
//
//
//
//
//

export default {
  name: 'BusinessRedirect',
  mounted: function mounted() {
    var _this = this;
    // 重定向到新的商户管理页面
    setTimeout(function () {
      _this.$router.push('/rs/merchant');
    }, 1000);
  }
};